.description {
  margin-bottom: var(--rc-theme-spacing-sm);
}
